import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SignStickerDetail } from 'src/app/model/sign/sticker/sign-sticker-detail';
import { SignStickerOverview } from 'src/app/model/sign/sticker/sign-sticker-overview';
import { LoadingService } from '../../../loading.service';
import { SnackService } from '../../../snack.service';
import { SignAssociationControllerRequestService } from '../sign-association-controller-request.service';

@Injectable({
  providedIn: 'root',
})
export class SignStickerControllerRequestService extends SignAssociationControllerRequestService<
  SignStickerDetail,
  SignStickerOverview
> {
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    super(http, snackService, loadingService, router, '/signstickers');
  }

  protected override deserializeImpl(): (res: any) => SignStickerDetail {
    return (res) => res as SignStickerDetail;
  }
}
